var items = document.querySelectorAll('.js-modal-toggle');

eventDispatcher.on('click', '.js-modal-toggle', function (event, element) {
    var target = element.dataset.target;

    var modal = document.getElementById(target + '-modal');

    if (modal) {
        window.modals = {};
        window.modals[target] = new Modal({ el: document.getElementById(target + '-modal') }).show();

        if (target + '-modal' === 'auth-modal') {
            document.querySelector('.auth-form__phone').focus();
        }
    } else {
        new Modal({ el: document.getElementById('default-modal') }).show();
    }
});

eventDispatcher.addAllEvent('click', '.js-modal-close', function (e) {
    var self = e.currentTarget;
    var parentSelector = self.dataset.target;

    var modal = window.modals[parentSelector];

    if (modal) {
        modal.hide();
    }
});

document.querySelectorAll('.js-toggle-rule').forEach(function (item) {
    item.addEventListener('click', function () {
        var currentItem = item.closest('.bonus-rule-item');
        var list = currentItem.parentElement;

        list.querySelectorAll('.bonus-rule-item').forEach(function (el) {
            if (el !== currentItem) {
                el.classList.remove('open');
            }
        });

        currentItem.classList.toggle('open');
    });
});